export default "__VITE_ASSET__52a0aa26__"